// @flow

import PropTypes from 'prop-types';

import type { ButtonTheme, SignOutActionCreator } from '../typings';
import config from '../../config';

import Button from './Button';

const { SHOULD_SHOW_SIGN_OUT_BUTTON } = config;

type Props = {
  buttonTheme: ButtonTheme,
  signOut: SignOutActionCreator
};

export default function SignOutButton({ buttonTheme, signOut }: Props) {
  if (!SHOULD_SHOW_SIGN_OUT_BUTTON) {
    return null;
  }
  return <Button width="205px" label="Sign out" buttonTheme={buttonTheme} onPress={signOut} />;
}

SignOutButton.propTypes = {
  buttonTheme: PropTypes.string,
  signOut: PropTypes.func
};
